// extracted by mini-css-extract-plugin
export default {"background":"core-skills-map_background__fZar9","sun":"core-skills-map_sun__57AWn","header":"core-skills-map_header__ahKaA","page":"core-skills-map_page__Guwdr"};